import { Vec3, clamp, direction, type Vec3Like } from '@mindcloudxai/shared';

export { clamp, direction };

export function normalize(v: Vec3Like): Vec3 {
  return Vec3.from(v).normalize(Vec3.FORWARD);
}

export function length(v: Vec3Like): number {
  return Vec3.from(v).length();
}

export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target.isContentEditable ||
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement
  );
}
